'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldWaiveSalesProOnboardingMon153Selector = exports.isMon153EligibleSelector = exports.isMon153VariantSelector = exports.mon153TreatmentSelector = exports.onboardingProgressSelector = undefined;

var _laboratoryLib = require('laboratory-lib');

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var onboardingProgressSelector = exports.onboardingProgressSelector = function onboardingProgressSelector(_ref) {
  var onboardingTasks = _ref.onboardingTasks,
      completedOnboardingTasks = _ref.completedOnboardingTasks;

  if (!onboardingTasks || !completedOnboardingTasks) return null;

  var allTasks = onboardingTasks.allTasks;

  // Need to filter bc not all completed tasks are in the list of onboarding tasks

  var relevantCompletedTasks = completedOnboardingTasks.completedTaskKeys.filter(function (taskKey) {
    return !!allTasks[taskKey];
  });

  var progress = relevantCompletedTasks.length / Object.keys(allTasks).length * 100;

  return progress;
};

var isSalesManagerSelector = function isSalesManagerSelector(_ref2) {
  var customerDemographics = _ref2.customerDemographics;

  return customerDemographics && customerDemographics.job_role === 'sales-director-manager';
};

var hasNewSalesLeaderChecklistSelector = function hasNewSalesLeaderChecklistSelector(_ref3) {
  var onboardingTasks = _ref3.onboardingTasks;

  if (!onboardingTasks) return null;

  // These keys are the labels for the three types of checklists
  // that mon153-eligible users will see, prefixed with "getting_started_" by the BE.
  // Source: https://git.hubteam.com/HubSpot/getting-started-shared-tasks/blob/master/static/js/groupKeys.js#L11-L17
  var NEW_SALES_LEADER_CHECKLISTS = ['getting_started_end_to_end_crm_inexperienced_sales_leader', 'getting_started_end_to_end_crm_experienced_sales_leader', 'getting_started_experienced_sales_leader'];
  return NEW_SALES_LEADER_CHECKLISTS.includes(onboardingTasks.tasksGroupKey);
};

var hasSkippedTasksSelector = function hasSkippedTasksSelector(_ref4) {
  var completedOnboardingTasks = _ref4.completedOnboardingTasks;
  return completedOnboardingTasks && completedOnboardingTasks.skippedTaskKeys.length > 0;
};

var isSalesProOnboardingRequiredSelector = function isSalesProOnboardingRequiredSelector(_ref5) {
  var requiredOnboarding = _ref5.requiredOnboarding;
  return requiredOnboarding[_MerchandiseIds.PRODUCT_SALES_PROFESSIONAL] && requiredOnboarding[_MerchandiseIds.PRODUCT_SALES_PROFESSIONAL].onboardingMerchandiseId === _MerchandiseIds.SERVICE_QUICK_START_CONSULTATION;
};

var mon153TreatmentSelector = exports.mon153TreatmentSelector = function mon153TreatmentSelector(_ref6) {
  var experimentTreatments = _ref6.experimentTreatments;

  var mon153Treatment = (0, _laboratoryLib.getTreatment)(experimentTreatments.treatments, 'monetization-153');
  return mon153Treatment;
};

var mon153ParameterSelector = function mon153ParameterSelector(state) {
  var treatment = mon153TreatmentSelector(state);
  return treatment && (0, _laboratoryLib.getParameter)(treatment.parameters, 'can-waive-onboarding');
};

var isMon153VariantSelector = exports.isMon153VariantSelector = function isMon153VariantSelector(state) {
  var param = mon153ParameterSelector(state);
  if (!param) return null;
  return param.value === 'true';
};

var isMon153EligibleSelector = exports.isMon153EligibleSelector = function isMon153EligibleSelector(state) {
  var isSalesManager = isSalesManagerSelector(state);
  var ownsSalesProOrEnt = (0, _ProductOwnershipSelectors.ownsProductOrHigherSelector)(state, _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL);
  var isSalesProOnboardingRequired = isSalesProOnboardingRequiredSelector(state);
  var hasEligibleChecklist = hasNewSalesLeaderChecklistSelector(state);
  var hasSkippedTasks = hasSkippedTasksSelector(state);
  var isExperimentOn = mon153ParameterSelector(state).isAssigned;
  return isSalesManager && !ownsSalesProOrEnt && isSalesProOnboardingRequired && hasEligibleChecklist && !hasSkippedTasks && isExperimentOn;
};

var shouldWaiveSalesProOnboardingMon153Selector = exports.shouldWaiveSalesProOnboardingMon153Selector = function shouldWaiveSalesProOnboardingMon153Selector(state) {
  var hasCompletedOnboarding = onboardingProgressSelector(state) === 100;
  var isMon153Eligible = isMon153EligibleSelector(state);
  var isInMon153Variant = isMon153VariantSelector(state);

  return hasCompletedOnboarding && isMon153Eligible && isInMon153Variant;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/Mon153WaivedOnboardingSelectors.js
// module id = 348
// module chunks = 3 4 5